import { Outlet } from 'react-router-dom';

import { BottomNav } from './BottomNav';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * Authenticated app chrome. Peach cream ground (`warm.white`) separates the
 * page background from the white card surfaces. Desktop: fixed left sidebar.
 * Mobile: fixed bottom tab bar with raised + button.
 */
export const AppShell = () => {
  return (
    <div className="min-h-dvh bg-warm-white">
      <Header />
      <div className="mx-auto flex max-w-6xl gap-0 px-0 pb-24 pt-0 md:gap-10 md:px-6 md:pb-12 md:pt-8">
        <Sidebar />
        <main className="min-w-0 flex-1 px-4 pt-6 sm:px-6 md:px-0 md:pt-0">
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
};
